<template>
    <div class="propertiesBoxMobile mx-0 box" v-if="selectedShape != null">

        <section class="bg-white pb-2 pb-lg-1 rounded-10 border-gris-pro pt-2 border-5">
            <div class="content-block px-2">
                <div class="mb-2">
                    <div class="one-block">
                        <div class="d-flex align-items-center justify-content-between">
                            
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-7 -7 230 230" height="17px">
                                    <path class="cls-1" d="M219.15,152.47h9.7a2.64,2.64,0,0,0,2.65-2.64V71.15a2.64,2.64,0,0,0-2.65-2.65h-78.7a2.64,2.64,0,0,0-2.65,2.65v9.7a2.64,2.64,0,0,0,2.65,2.65h55.74L144.1,145.3a2.63,2.63,0,0,0,0,3.74L151,155.9a2.63,2.63,0,0,0,3.74,0l61.8-61.79v55.72A2.64,2.64,0,0,0,219.15,152.47Z" transform="translate(-15 -68.5)"/>
                                    <path class="cls-2" d="M17.65,285h78.7A2.64,2.64,0,0,0,99,282.35v-9.7A2.64,2.64,0,0,0,96.35,270H40.61l61.82-61.83a2.63,2.63,0,0,0,0-3.74l-6.86-6.86a2.63,2.63,0,0,0-3.74,0L30,259.39V203.65A2.64,2.64,0,0,0,27.35,201h-9.7A2.64,2.64,0,0,0,15,203.65v78.7A2.64,2.64,0,0,0,17.65,285Z" transform="translate(-15 -68.5)"/>
                                </svg>
                                <t class="ml-1 font-weight-bold" propertiesBox.size v-if="!selectedShape.accepts('resize-radius')" />
                                <t class="ml-1 font-weight-bold" propertiesBox.radius v-else />
                            </div>

                            <div class="d-flex" v-if="selectedShape.accepts('resize')">
                                <div class="mr-1">
                                    <div class="w-100 position-relative input-number bg-gris-pro rounded-10 px-1">
                                        <input type="number" v-model="width" @input="updateSize" @click="textFocus" @blur="textBlur" @keyup.enter="unFocus()" v-on:keyup.page-down="unFocus()" />
                                        <span class="suffix-detail" v-if="width"><span>{{width}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                        <span class="indicator"><t propertiesBox.l /></span>
                                    </div>
                                </div>
                                <div class="ml-1">
                                    <div class="w-100 position-relative input-number bg-gris-pro rounded-10 px-1">
                                        <input type="number" class="rounded-10" v-model="height" @input="updateSize" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                        <span class="suffix-detail" v-if="height"><span>{{height}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                        <span class="indicator"><t propertiesBox.h /></span>
                                    </div>
                                </div>
                                <div class="checkbox mt-1" v-if="keepProportions != null">
                                    <input type="checkbox" id="keepProportions" name="keepProportions" v-model="keepProportions" :checked="keepProportions"  @change="updateKeepProportions" @click="textFocus" @blur="textBlur" >
                                    <label class="cursor-pointer mb-0" for="keepProportions"><t propertiesBox.keepProportions /></label>
                                </div>
                            </div>

                            <div v-if="selectedShape.accepts('resize-radius')">
                                <div class="w-100 position-relative input-number select bg-gris-pro rounded-10 px-0">
                                    <select class="px-1 font-weight-bold" v-if="drillingDiameters.length > 0 && radius < cuttingOptions.drillingThresholdDiameter/2 " @change="updateRadius('select')" v-model="diameter">
                                        <option v-for="limits in drillingDiameters" :value="limits" :key="limits">{{limits}}</option>
                                        <option :value="cuttingOptions.drillingThresholdDiameter" :key="cuttingOptions.drillingThresholdDiameter">>{{cuttingOptions.drillingThresholdDiameter}} <t propertiesBox.mm /></option>
                                    </select>
                                    <div class="w-100 position-relative input-number d-flex align-items-center" v-if="radius >= cuttingOptions.drillingThresholdDiameter/2">
                                        <div class="px-1 d-flex align-items-center">
                                            <input id="switchUpFocus"  type="number" step="0,01" v-model="diameter" @click="textFocus" @blur="textBlur" v-on:keyup="validateRadius=true" v-on:keyup.enter="unFocus(), updateRadius()"/>
                                            <div id="radius-resize" class="indicator h-100 d-flex">
                                                <span class="h-100 d-flex align-items-center"><t propertiesBox.r /></span>
                                            </div>
                                        </div>
                                        <button v-if="validateRadius" class="btn rounded-right-10 btn-jaune text-uppercase border-0 font-weight-bold p-2 text-white"  @click="updateRadius">
                                            <t propertiesBox.ok />
                                        </button>
                                    </div>
                                    <span class="suffix-detail"><span>{{diameter}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="one-block" v-if="selectedShape.accepts('move') && !selectedShape.isOrigin && selectedShape.isCut">
                        <div class="d-flex align-items-center justify-content-between">

                            <div class="d-flex align-items-center">
                                <b-icon icon="arrows-move" class="cursor-pointer" font-scale="1.1" />
                                <t class="ml-1 font-weight-bold" propertiesBox.position />
                            </div>

                            <div class="d-flex">
                                <div class="mr-1">
                                    <div class="w-100 position-relative input-number bg-gris-pro rounded-10 px-1">
                                        <input type="number" v-model="positionX" @input="updatePosition" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                        <span class="suffix-detail" v-if="positionX"><span>{{positionX}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                        <span class="indicator"><t propertiesBox.x /></span>
                                    </div>
                                </div>
                                <div class="ml-1">
                                    <div class="w-100 position-relative input-number bg-gris-pro rounded-10 px-1">
                                        <input type="number" v-model="positionY" @input="updatePosition" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                                        <span class="suffix-detail" v-if="positionY"><span>{{positionY}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                                        <span class="indicator"><t propertiesBox.y /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox mt-2" v-if="selectedShape.accepts('pockets')">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center justify-content-center position-relative">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 100.9 100.9" height="17px">
                                    <rect class="cls-1" x="5.4" y="5.4" width="84.1" height="84.1" fill="white" stroke="#343a40" stroke-width="6" />
                                    <circle class="cls-1" cx="8.5" cy="8.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                    <circle class="cls-1" cx="8.4" cy="86.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                    <circle class="cls-1" cx="86.5" cy="86.5" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                    <circle class="cls-1" cx="86.5" cy="8.4" r="7.9" fill="white" stroke="#343a40" stroke-width="6"/>
                                    <rect x="8.9" y="8.9" width="16" height="16" fill="white" class="cls-2"></rect>
                                    <rect x="70" y="8.9" width="16" height="16" fill="white" class="cls-2"></rect>
                                    <rect x="70" y="70" width="16" height="16" fill="white" class="cls-2"></rect>
                                    <rect x="9" y="70" width="16" height="16" fill="white" class="cls-2"></rect>
                                </svg>
                                <span class="text-dark font-weight-bold ml-1"><t propertiesBox.pockets /></span>
                            </div>
                            <div>
                                <b-form-checkbox switch v-model="pockets" @change="updatePockets" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-gris-pro rounded-10 px-3 py-2"  v-if="selectedShape.accepts('text') || selectedShape.accepts('text') ||selectedShape.accepts('rotate') || selectedShape.accepts('round-corners') || selectedShape.accepts('triangle') || selectedShape.accepts('svg')">
                    <div class="one-block mt-0" v-if="selectedShape.accepts('text') && availableFonts.length > 1">
                        <span class="font-weight-bold label d-block text-dark"><t propertiesBoxMobile.font /></span>
                        <v-select class="toplevel bg-white rounded-10" :value="propFontName" :reduce="font => font.name" label="name" :options="availableFonts" :clearable="false" @input="updateFont">
                            <template slot="option" slot-scope="option" class="rounded-10">
                                <svg height="1.7em" viewBox="-20 -20 1000 150" v-html="option.sample" />
                            </template>
                        </v-select>
                    </div>
                    <div class="one-block" v-if="selectedShape.accepts('text')">
                        <span class="font-weight-bold label d-block text-dark"><t propertiesBoxMobile.content /></span>
                        <div class="d-flex mb-3">
                            <input class="w-100 rounded-left-10 border-right-0 font-weight-normal bg-white" v-model="content" @click="textFocus" @blur="textBlur" v-on:keyup.enter="updateContent()" />
                            <button class="rounded-right-10 btn-ok" v-on:click="updateContent()"><t propertiesBoxMobile.ok /></button>
                        </div>
                    </div>
                    <div v-if="selectedShape.accepts('rotate')" class="d-flex justify-content-between align-items-center">
                        <div class="w-100">
                            <span class="font-weight-bold d-block text-dark"><t propertiesBoxMobile.rotation /></span>
                            <vue-slider
                                v-model="rotation"
                                :min="-180"
                                :max="180"
                                :tooltip="'none'"
                                :contained="true"
                                :interval="1"
                                class="pl-0"
                                @change="updateRotation"
                                @drag-start="preventRepaint"
                                @drag-end="allowRepaint"
                            />
                        </div>
                        <div class="position-relative input-number bg-white rounded-10">
                            <input type="number" class="pl-2" v-model="rotation" @input="updateRotation" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                            <span class="suffix-detail degrees" v-if="rotation || rotation == 0"><span>{{rotation}}</span> <span class="suffix"><t propertiesBox.degrees /></span></span>
                        </div>
                    </div>


                    <div id="round-corners" v-if="selectedShape.accepts('round-corners') && !this.multipleCorner" class="d-flex justify-content-between align-items-center">
                        <div class="w-100">
                            <span class="d-flex align-items-center mt-1">
                                <t class="font-weight-bold" propertiesBox.roundedCorner />
                            </span>
                            <vue-slider
                                class="pl-0"
                                v-model="corner"
                                :min="0"
                                :max="maxCorner"
                                :tooltip="'none'"
                                :contained="true"
                                :interval="1"
                                @change="updateCorner"
                                @drag-start="preventRepaint"
                                @drag-end="allowRepaint"
                            />
                        </div>
                        <div class="position-relative input-number bg-white rounded-10">
                            <input type="number" v-model="corner" @input="updateCorner" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                            <span class="suffix-detail" v-if="corner || corner == 0"><span>{{corner}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                        </div>
                    </div>

                    <div v-if="selectedShape.accepts('triangle')" class="d-flex justify-content-between align-items-center">
                        <div class="w-100">
                            <span class="font-weight-bold d-block text-dark"><t propertiesBoxMobile.topPosition /></span>
                            <vue-slider
                                v-model="heightPos"
                                :min="0"
                                :max="width"
                                :tooltip="'none'"
                                :contained="true"
                                :interval="1"
                                class="pl-0"
                                @change="updateHeightPos"
                                @drag-start="preventRepaint"
                                @drag-end="allowRepaint"
                            />
                        </div>
                        <div class="position-relative input-number bg-white rounded-10">
                            <input type="number" class="pl-2" v-model="heightPos" @input="updateHeightPos" @click="textFocus" @blur="textBlur" v-on:keyup.enter="unFocus()" />
                            <span class="suffix-detail" v-if="heightPos || heightPos == 0"><span>{{heightPos}}</span> <span class="suffix"><t propertiesBox.mm /></span></span>
                        </div>
                    </div>

                    <div id="shape" class="one-block pb-2 mt-0" v-if="selectedShape.accepts('svg')">
                        <span class="font-weight-bold label d-block text-white"><t propertiesBoxMobile.shape /></span>

                        <b-button v-b-modal.icons-modal variant="light" class="p-0 d-flex w-100 align-items-center border-0 rounded-10">
                            <div class="rounded-left-10 px-2 py-1">
                                <svg v-if="icon" height="23px" :viewBox="icon.xmin + ' ' + icon.ymin + ' ' + icon.xmax + ' ' + icon.ymax">
                                    <path :d="icon.path"></path>
                                </svg>
                            </div>
                            <span class="bg-gris w-100 rounded-right-10 text-white mb-0"><t propertiesBoxMobile.changeShape /></span>
                        </b-button>
                    </div>
                </div>

                <div class="one-block" v-if="selectedShape.type == 'imported'">
                    <span class="font-weight-bold label d-block"><t propertiesBoxMobile.typeLine /></span>
                    <div v-if="selectedShape.family == 'cut'"><t propertiesBoxMobile.cutLine /></div>
                    <div v-if="selectedShape.family == 'bend'"><t propertiesBoxMobile.foldLine /></div>
                </div>
            </div>
        </section>

        <b-modal id="icons-modal" ref="icons-modal" size="xl" hide-footer centered scrollable modal-class="bg-transparent" body-class="p-0 bg-transparent" content-class="bg-transparent border-0">
            <div class="bg-rose rounded-top-10 d-flex justify-content-between flex-column py-3">
                <div>
                    <h3 class="text-white text-center font-weight-bold h5 line-height mb-2"><t propertiesBox.categories /></h3>
                </div>

                <div class="d-flex align-items-center justify-content-center flex-wrap">
                    <div @click="selectedCategory = 'all'" class="cursor-pointer mt-0 one-category">
                        <span class="h6 font-weight-normal text-white mb-0 mt-0 cursor-pointer mx-2"><t propertiesBox.all /></span>
                    </div>
                    <div
                    v-for="category in categories"
                    v-bind:key="category.name"
                    @click="selectedCategory = category.name"
                    class="cursor-pointer mt-0 one-category">
                        <span class="h6 font-weight-normal text-white mb-0 text-capitalize mx-2" :class="{'active' : selectedCategory == category.name}">{{category.name}}</span>
                    </div>
                </div>
            </div>
            <div class="pl-2 pr-0 bg-white">
                <div class="icons py-2 pr-2">
                    <b-button
                        variant="light"
                        class="icon col-3 m-0 p-1 border-0"
                        v-for="icon in iconsOfCategory"
                        @click="selectIcon(icon)"
                        v-bind:key="icon.name">
                        <div class="icon-svg p-3">
                            <svg height="3em" :viewBox="icon.xmin + ' ' + icon.ymin + ' ' + icon.xmax + ' ' + icon.ymax">
                                <path :d="icon.path"></path>
                            </svg>
                        </div>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import vSelect from 'vue-select'
import { models } from 'feathers-vuex';
import { paper, Point } from 'paper';
import { VBModal, BButton, BCol, BBadge, BListGroupItem, BListGroup, BRow, BContainer, BModal, BIcon, BIconSliders, BFormCheckbox, BIconTrashFill, BIconLockFill, BIconUnlockFill, BIconBack, BIconArrowsMove, BIconArrowsAngleExpand, BIconSubtract, BIconBootstrapReboot, BIconSquare, BIconCaretDownFill, BIconInfoCircleFill, BIconKeyboard, BIconTextareaT } from 'bootstrap-vue';
import { mapGetters, mapActions } from 'vuex';
import PathUtils from '@/services/PathUtils';
import ToolsUtils from '@/services/ToolsUtils'

export default {
    /* eslint-disable vue/no-unused-components */
    components: {
        VueSlider,
        vSelect,
        BButton,
        BCol,
        BBadge,
        BListGroupItem,
        BListGroup,
        BRow,
        BContainer,
        BModal,
        BIcon,
        BIconSliders,
        BFormCheckbox,
        BIconTrashFill,
        BIconLockFill,
        BIconUnlockFill,
        BIconBack,
        BIconArrowsMove,
        BIconArrowsAngleExpand,
        BIconSubtract,
        BIconBootstrapReboot,
        BIconSquare,
        BIconCaretDownFill,
        BIconInfoCircleFill,
        BIconKeyboard,
        BIconTextareaT
    },
    directives: {'b-modal': VBModal },
    data() {
        return {
            shapeId: null,
            corner: null,
            rotation: null,
            width: null,
            height: null,
            centerx: null,
            centery: null,
            content: null,
            autoSize: null,
            fontSize: null,
            radius: null,
            fonts: null,
            pockets: null,
            icons: [],
            iconName: null,
            keepProportions: null,
            selectedCategory: 'all',
            validateRadius: false,
            isOrigin: null,
            positionX: null,
            positionY: null,
            heightPos: null,
            tuto: null,
            iconModal: null,
            notCuttable: false,
            diameter : this.radius*2
        }
    },

    async mounted() {
        this.fonts = this.refreshFonts();
        this.icons = this.refreshIcons();

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId == 'icons-modal') {
                this.$store.dispatch('openIconsChoice', false);
            }
        });
    },

    computed: {
        ...mapGetters([
            'propRadius',
            'propRotation',
            'propCorner',
            'propPockets',
            'propPosition',
            'propSize',
            'propKeepProportions',
            'propHeightPos',
            'propFontName',
            'maxCorner',
            'propFontSize',
            'propAutoSize',
            'propTextContent',
            'propIconName',
            'selectedShape',
            'zoom',
            'isOpenIconsModal',
            'isDropped',
            'cuttingOptions'
        ]),

        icon: function() {
            return this.icons.find(i => i.name == this.iconName);
        },

        categories: function() {
            let categories = [];

            if (this.icons && this.icons.length > 0) {
                let icons = this.icons.filter(i => i.active && i.categories.length > 1);
                icons.forEach(category => {
                    category.categories.forEach(catt => {
                        categories.push(catt);
                    });
                });
                categories = [...new Set(categories)];
            }

            return categories;
        },

        iconsOfCategory: function() {
            let list = [];

            if (this.icons && this.icons.length > 0) {
                list = this.icons.filter(i => !i.iscategory && i.categories.includes(this.selectedCategory) && i.active != false);
                if (this.selectedShape && this.selectedShape.isCut) {
                    list = list.filter(i => i.cuttable);
                }
            }

            return list;
        },

        availableFonts: function() {
            if (!this.fonts || this.selectedShape == null) return null;
            let type = this.selectedShape.isCut ? 'cut' : 'material';
            return this.fonts.filter(f => f.type == type && f.active);
        },

        drillingDiameters: function(){
            let drillingDiameter = Object.fromEntries(Object.entries(this.cuttingOptions).filter(([key]) => key.startsWith('drillingDiameter')));
            return drillingDiameter = Object.values(drillingDiameter).sort(function(a, b) {return a - b;});
        }
    },

    watch: {
        isOpenIconsModal: async function(iconModal) {
            if (this.iconModal != iconModal) this.iconModal = iconModal;
        },

        selectedShapeIds: async function(shapeIds) {
            if (shapeIds.length == 1) {
                this.initializeProperties(shapeIds[0]);
            } else {
                this.selectedShape = null;
            }
        },

        selectedShape: async function(selectedShape) {
            if (!selectedShape) {
                this.shapeId = null;

                return;
            } else {
                this.tuto = null;
            }

            if (this.shapeId == selectedShape.id) return;

            this.shapeId = selectedShape.id;

            if (this.isDropped == 'setting') {
                this.$nextTick(() => {
                    document.querySelector('.animation').style.height = document.querySelector('#setting').offsetHeight + 'px';
                });
            }
        },

        propRadius: async function(radius) {
            if (this.radius != radius) {
                this.radius = radius;
                this.diameter = this.radius*2;
            }
        },

        propRotation: async function(rotation) {
            if (this.rotation != Math.round(rotation)) this.rotation = Math.round(rotation);
        },

        propCorner: async function(corner) {
            if (this.corner != corner) this.corner = corner;
        },

        propPockets: async function(pockets) {
            if (this.pockets != pockets) this.pockets = pockets;
        },

        propPosition: async function(position) {
            if (this.positionX != position.x) this.positionX = position.x;
            if (this.positionY != position.y) this.positionY = position.y;
        },

        propSize: async function(size) {
            if (this.width != size.width) this.width = size.width;
            if (this.height != size.height) this.height = size.height;
        },

        propKeepProportions: async function(keepProportions) {
            if (this.keepProportions != keepProportions) this.keepProportions = keepProportions;
        },

        propHeightPos: async function(heightPos) {
            if (this.heightPos != heightPos) this.heightPos = heightPos;
        },

        propFontSize: async function(fontSize) {
            if (this.fontSize != fontSize) this.fontSize = fontSize;
        },

        propAutoSize: async function(autoSize) {
            if (this.autoSize != autoSize) this.autoSize = autoSize;
        },

        propTextContent: async function(content) {
            if (this.content != content) this.content = content;
        },

        propIconName: async function(iconName) {
            if (this.iconName != iconName) this.iconName = iconName;
        }
    },

    methods: {
        ...mapActions([
            'preventRepaint',
            'allowRepaint',
            'textFocus',
            'textBlur'
        ]),

        async refreshIcons() {
            let blockSize = 20;
            let response = await models.api.Icon.find({query: {$limit: blockSize}});
            this.icons = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Icon.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.icons = this.icons.concat(response.data);
            }
        },

        async refreshFonts() {
            let blockSize = 20;
            let response = await models.api.Font.find({query: {$limit: blockSize}});
            this.fonts = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Font.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.fonts = this.fonts.concat(response.data);
            }
        },

        async updateRadius() {
            this.radius = this.diameter/2;
            if(this.radius < this.cuttingOptions.drillingThresholdDiameter/2){
                this.radius = ToolsUtils.drillingDiameter(this.radius, this.cuttingOptions.drillingThresholdDiameter/2, this.cuttingOptions);
                this.diameter = this.radius * 2;
            }
            let radius = parseFloat(this.radius);
            let center = this.selectedShape.center;
            await this.$store.dispatch('setRadius', {radius, center});
            this.validateRadius = false;
            if(this.radius == this.cuttingOptions.drillingThresholdDiameter/2 && input == 'select') {
                document.getElementById("switchUpFocus").focus()
            }
            this.$store.dispatch('setDropped', null);
        },

        async updateRotation() {
            await this.$store.dispatch('setRotation', parseFloat(this.rotation));
        },

        async updateCorner() {
            await this.$store.dispatch('setCorner', parseFloat(this.corner));
        },

        async updatePockets(checked) {
            this.pockets = checked;
            await this.$store.dispatch('setPockets', this.pockets);
        },

        async updatePosition() {
            await this.$store.dispatch('setPosition', {
                x: parseFloat(this.positionX),
                y: parseFloat(this.positionY)
            });
        },

        async updateSize() {
            let size = {
                width: parseFloat(this.width),
                height: parseFloat(this.height)
            };
            let center = {
                x: this.selectedShape.point.x + size.width / 2,
                y: this.selectedShape.point.y + size.height / 2
            };
            await this.$store.dispatch('setSize', {size, center});
        },

        async updateKeepProportions() {
            await this.$store.dispatch('setKeepProportions', this.keepProportions);
        },

        async updateHeightPos() {
            await this.$store.dispatch('setHeightPos', parseFloat(this.heightPos));
        },

        async updateFont(fontName) {
            await this.$store.dispatch('setFontName', fontName);
        },

        async updateFontSize() {
            await this.$store.dispatch('setFontSize', this.fontSize);
        },

        async updateAutoSize() {
            await this.$store.dispatch('setAutoSize', this.autoSize);
        },

        async updateContent() {
            await this.$store.dispatch('setTextContent', this.content);
            this.$store.dispatch('setDropped', null);
        },

        async selectIcon(icon) {
            await this.$store.dispatch('setIconName', icon.name);

            if (this.selectedShape == null || this.selectedShape.type != 'materialsvg') {    
                this.$store.dispatch('setWhiteboardTool', 'svg');            
                this.$store.dispatch('setSvgPattern',icon.path);
                this.$store.dispatch('setSvgName',icon.name);
                paper.tools.find(t => t.name === 'svg').displayIcon();
            }

            this.$refs['icons-modal'].hide();
        },

        lockShape: function(shape) {
            shape.locked = !shape.locked;
            this.$store.dispatch('patchShape', shape);
            paper.tools.find(t => t.name === 'selecter').initSelectionRectangle()
        },

        cloneShape: function(shape) {
            if(shape.locked) return false;
            let clonedShape = shape.clone();
            this.$store.dispatch('addToolShape', clonedShape);
            clonedShape.move(new Point(shape.sizeW + 10, 0));
            PathUtils.zoomOnClone(shape,clonedShape);
        },

        centerOrigin: async function() {
            let shapes = this.$store.getters.shapes;
            let center = this.$store.getters.center;
            let shapeCenter = this.selectedShape.bounds.center.multiply(-1);
            shapes.forEach(element => {
                (element.id != this.selectedShape.id)?element.move(shapeCenter): element.move(shapeCenter);this.$store.dispatch('setSelectedShape', element);
            });
            center = center.add(shapeCenter);
            await this.$store.dispatch('patchShapes',shapes);
            await this.$store.dispatch('setCenter',center);
            paper.tools.find(t => t.name === 'selecter').initSelectionRectangle();
        },

        hideModal() {
            this.$refs['icons-modal'].hide();
            this.$store.dispatch('openIconsChoice', false);
        },

        openIconsModal() {
            if (this.isOpenIconsModal) {
                this.$store.dispatch('openIconsChoice', false);
            } else {
                this.$store.dispatch('openIconsChoice', true);
            }
        },

        unFocus() {
            document.querySelectorAll('.propertiesBoxMobile input').forEach(function(e) {
                e.blur();
            });
            this.$store.dispatch('setDropped', null);
        },

        async updateRoundCorner() {

            let max = this.maxCorner;
            let min = 0;
            this.cornerTopLeft = (this.cornerTopLeft > max)? max : (this.cornerTopLeft < 0)? min : parseFloat(this.cornerTopLeft);
            this.cornerTopRight = (this.cornerTopRight > max)? max : (this.cornerTopRight < 0)? min : parseFloat(this.cornerTopRight);
            this.cornerBottomLeft = (this.cornerBottomLeft > max)? max : (this.cornerBottomLeft < 0)? min : parseFloat(this.cornerBottomLeft);
            this.cornerBottomRight = (this.cornerBottomRight > max)? max : (this.cornerBottomRight < 0)? min : parseFloat(this.cornerBottomRight);
            var roundCorner = {"topLeft" : this.cornerTopLeft, "topRight" : this.cornerTopRight,  "bottomLeft" : this.cornerBottomLeft, "bottomRight" : this.cornerBottomRight};

                await this.$store.dispatch('setRoundCorner', roundCorner);
                await this.selectedShape.setRoundCorner(roundCorner);
                await this.$store.dispatch('setCorner', 0);
        },
    },
}
</script>


<style lang="scss">
    @import '../../assets/slider.css';
    @import './../../assets/scss/_variables.scss';

    .propertiesBoxMobile {
        .input-number {
            input {
                padding: 0.3rem;
            }
            .suffix-detail {
                left: -3px;
            }
        }
        .indicator {
            font-size: 80%;
            font-weight: bold;
        }
        .suffix-detail {
            display: flex;
        }

        @media (max-width: 340px) {
            svg {
                display: none!important;;
            }
        }

        .vs__selected {
            position: relative!important;
        }

        .vs__dropdown-toggle {
            border: 0;
        }
    }
    
    .toplevel {
        z-index: 2;
    }
    
    .input-small {
        width: 67px!important;
    }
    .content-block {
        input {
            padding: 0.3rem;
            width: 70px;
            background: $grispro;
            color: $gris;
            border: 0;
            border-radius: 10px;
            font-weight: 700;
            outline: none;
        }

        select {
            width: 97px;
            padding: 10px;
            border: 2px solid $grispro;
            border-radius: 10px;
            outline: none;
            font-size: 1rem;
            color: #6c757d;

            @media (max-width: 769px) {
                padding: 5px 0;
                border: 0;
                z-index: 2;
                position: relative;
                background: transparent;
            }
        }
    }
    #radius-resize {
        font-size: 100%;
    }
    #mobile-settings {
        .dropdown-menu {
            z-index: -1;

            .bg-white {
                background: $grispro!important;
            }
        }
    }
    .label {
        margin-right: .5rem;
    }
    .one-block {
        margin-bottom:.6rem;

        span {
            margin-bottom: .2rem;
        }
    }
    .btn-ok {
        background: $gris;
        color: $white;
        font-weight: 600;
        padding: 0 10px;
        border: none;
    }
    .checkbox {
        label {
            position: relative;
            margin-left: 27px;

            &:before {
                background-color: #dee2e6;
                border: 0;
                border-radius: .25rem;
            }
            &:before,
            &:after {
                position: absolute;
                top: .25rem;
                left: -1.5rem;
                display: block;
                width: 1rem;
                height: 1rem;
                content: "";
            }
        }

        input {
            &[type="checkbox"] {
                display: none!important;
            }

            &:checked{
                &~label {
                    &:before {
                        color: $white;
                        border-color: $jaune!important;
                        background-color: $jaune!important;
                        box-shadow: 0 0 0 0.2rem rgba($jaune,.25);
                    }
                    &:after {
                        background-image: url('./../../assets/img/check-editeur.svg');
                        background-repeat: no-repeat;
                        background-position: 50%;
                    }
                }
            }

            &:not(:checked) {
                ~.d-none {
                    display: flex!important;
                }
            }
        }
    }

    #icons-modal {
        h3 {
            border-bottom: 1px solid white;
            width: 80%;
            margin: 0 auto;
            padding-bottom: 7px;
        }
    }

    /* The sidebar menu */
    .icons {
        .icon {
            padding: 1em;
            background-color: #eee;
            margin: 0.5em;
            border: 2px solid #ddd;
        }
    }
</style>
